import * as React from 'react';
import styles from './index.less';
import FComponentsLib from '@freelog/components-lib';
import FResourceTypeInput4 from '@/components/FResourceTypeInput4';
import FDrawer from '@/components/FDrawer';
import { Space } from 'antd';
import { FI18n, FUtil } from '@freelog/tools-lib';
import FIcons from '@/components/FIcons';

type ValueType = {
  value: string;
  labels: string[];
  customInput?: string;
} | null;

interface ResourceTypeInputDrawerProps {
  onOk?(value: ValueType): void;

  onClose?(): void;
}

function ResourceTypeInputDrawer({ onOk, onClose }: ResourceTypeInputDrawerProps) {

  const [$open, set$open, get$open] = FUtil.Hook.useGetState<boolean>(true);
  const [$value, set$value, get$value] = FUtil.Hook.useGetState<ValueType>(null);

  return (<FDrawer
    title={FI18n.i18nNext.tAuto('storage_bulkaction_settype_title')}
    open={$open}
    topRight={<Space size={30}>
      <FComponentsLib.FTextBtn
        type='default'
        onClick={() => {
          set$open(false);
        }}
      >{FI18n.i18nNext.tAuto('btn_cancel')}</FComponentsLib.FTextBtn>

      <FComponentsLib.FRectBtn
        type='primary'
        onClick={() => {
          onOk && onOk(get$value());
          set$open(false);
        }}
      >{FI18n.i18nNext.tAuto('btn_save')}</FComponentsLib.FRectBtn>
    </Space>}
    afterOpenChange={(o) => {
      if (!o) {
        onClose && onClose();
      }
    }}
  >
    <FComponentsLib.FContentText
      text={FI18n.i18nNext.tAuto('storage_bulkaction_settype_input_type')}
      type={'highlight'}
    />
    <div style={{ height: 5 }} />
    <FResourceTypeInput4
      value={$value}
      onChange={(value) => {
        set$value(value);
      }}
    />
    <div style={{ height: 20 }} />
    <div className={styles.footer}>
      <div style={{ fontSize: 12, lineHeight: '18px', color: '#BEBEBE' }}><FIcons.FInfo
        style={{ fontSize: 12 }} />&nbsp;{FI18n.i18nNext.tAuto('storage_bulkaction_settype_input_type_msg')}</div>
    </div>
  </FDrawer>);
}

export default ResourceTypeInputDrawer;
